import { Component, OnInit } from '@angular/core';
import { ScrollService } from '../../../_services/scroll.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public currentUser: unknown = null;
  constructor(
    public router: Router,
    private scrollService: ScrollService,
    private authenticationService: AuthService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authenticationService.userData;
  }

  scrollToId(id: string) {
    this.router.navigate(['/']);
    setTimeout(() => this.scrollService.scrollToElementById(id), 100);
  }
}
